<div class="tiers-partie-detail">
	<div class="modal-header">
		<h2 class="modal-title" [translate]="'Labels.' + libelleKey"></h2>
		<button type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
	</div>

	<div class="modal-body">
		<table class="table table-borderless">
			<tbody>
				<tr *ngFor="let tiers of tiersPartie">
					<td>
						<strong>{{ setNomEmetteurFromTiers(tiers) }}</strong>
					</td>
					<td *ngIf="tiers.type === tiersType.PersonnePhysique; else personneMorale">
						{{ tiers.dateNaissance ? formatDate(tiers.dateNaissance) : '' }}
					</td>
					<td style="width: 0%">
						<button
							[matTooltip]="'Actions.Consult' | translate"
							class="btn btn-icon btn-icon-sm"
							container="body"
							(click)="showTiers(tiers)"
						>
							<i class="far fa-eye"></i>
						</button>
					</td>

					<td style="width: 0%"
						*ngIf="((userPermission.TiersCanUpdate | hasPermission) || fromFO)
					    && isCompteBancaireClos !== true"
						>
						<button
							[matTooltip]="'Actions.Edit' | translate"
							class="btn btn-icon btn-icon-sm"
							container="body"
							(click)="onEditTier(tiers)"
						>
							<i class="far fa-edit"></i>
						</button>
					</td>

					<ng-template #personneMorale>
						<td>{{ tiers.registre ? tiers.registre : '' }}</td>
					</ng-template>
				</tr>
			</tbody>
		</table>
	</div>
</div>
